<template>
  <b-form-group
    :label="$t('fields.status')"
    label-for="status"
  >
    <b-form-checkbox
      id="status"
      v-model="dataItem.status"
      :value="1"
      :unchecked-value="0"
      switch
    >
      {{ dataItem.status === 1 || dataItem.status === '1' ? $t('common.active') : $t('common.passive') }}
    </b-form-checkbox>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'GuidesStatusCard',
  components: { BFormGroup, BFormCheckbox },
  computed: {
    dataItem() {
      return this.$store.getters['guides/dataItem']
    },
  },
}
</script>
